module.exports = __webpack_public_path__ + "img/almeria-logo-icon.2db2d94f.png";